import React, {useContext} from "react";
import {Text, View, Image} from "react-native";
import MainStyle from "../../MainStyle";
import location from "../assets/img/icons/map-pin-range-line 1.svg";
import {Challenge} from "../../generated/smg_service_pb";
import {setContestFrameImage} from "../utils";
import liveChallengeIndicationGraphics from "../assets/img/live-challange-indication-grapics.png";
import {Entypo} from '@expo/vector-icons';
import {StoreContext} from "./StoreContextProvider";
import Div from "../lib/Div";
import {colors} from "../assets/styles/colors";

type Props = {
  betType: string, type: 'open' | 'accepted', onArrowForwardPress: () => void,
  largestDistanceChallenge?: Challenge
};

const ContestFrame = (props: Props) => {
  const {betType, type, largestDistanceChallenge} = props;
  const source = setContestFrameImage(betType);
  const Context = useContext(StoreContext);
  const {extendedUserData} = Context;

  const renderPoint = () => {
    if (betType === 'paytable') {
      const distance = largestDistanceChallenge ? Number(largestDistanceChallenge.value1) / 36 : 0;

      return (
        <Div position="absolute" w={85} top={11} left={168}>
          <Text style={[...styles.distance, styles.shadow]}>{distance} yds</Text>
          <Entypo name="triangle-down" size={14} color="white" style={[MainStyle.m_x_auto, styles.shadow]}/>
        </Div>
      );

    } else return null;
  };

  return (
    <Div h={187} rounded={20} position="relative" overflow="hidden" mb={10} bg={colors.placeholder}>
      <Image
        source={type === 'open' ? source : liveChallengeIndicationGraphics}
        style={[MainStyle.h_240, MainStyle.rm_cover]}
      />

      <Div position="absolute" top={8} left={7} row w={160} alignItems="center">
        <Div w={48} h={48} rounded={50} bg={colors.settings_bg} justifyContent="center">
          <Image source={location as any} style={[MainStyle.w_24, MainStyle.h_24, MainStyle.m_x_auto]}/>
        </Div>
        <Text style={[...styles.title, styles.shadow]}>Closest to the Pin</Text>
      </Div>

      {type === 'open' && renderPoint()}

      {(extendedUserData.isNewPlayer || extendedUserData.freeShotNumber !== extendedUserData.freeShotCount) && (
        <View style={[MainStyle.absolute, MainStyle.b_0, MainStyle.full_w]}>
          <Text style={styles.freeShots}>
            {type === 'open' ? `${extendedUserData.freeShotCount} Free Shots` : `Free Shot ${extendedUserData.freeShotNumber} of ${extendedUserData.freeShotCount}`}
          </Text>
          <Text style={styles.banner}>See How Much Money You Can Win*!</Text>
        </View>
      )}

      {/*<Div position="relative" flex={1}>*/}
      {/*  <Div position="absolute" style={MainStyle.t_50_percent} right="0" mr={-24}>*/}
      {/*    <Button w={48} h={48} bg={colors.unselect} borderWidth={1} shadow="lg" rounded={56}*/}
      {/*            borderColor="rgba(0, 0, 0, 0.5)" onPress={props.onArrowForwardPress}>*/}
      {/*      <Ionicons name="ios-chevron-forward" size={40} color="white"/>*/}
      {/*    </Button>*/}
      {/*  </Div>*/}
      {/*</Div>*/}
    </Div>
  );
};

const styles = {
  title: [MainStyle.c_white, MainStyle.Barlow500, MainStyle.f_s_22, MainStyle.m_l_10],
  distance: [MainStyle.c_white, MainStyle.t_a_c, MainStyle.Barlow500, MainStyle.f_s_22],
  shadow: {textShadowColor: 'rgba(0, 0, 0, 0.50)', textShadowOffset: {width: 0, height: 2}, textShadowRadius: 2},
  banner: [
    MainStyle.l_h_24, MainStyle.bg_newGreen, MainStyle.c_black, MainStyle.t_a_c, MainStyle.Barlow700,
    MainStyle.f_s_16, MainStyle.t_t_u
  ],
  freeShots: [
    MainStyle.c_white, MainStyle.t_a_c, MainStyle.textShadow, MainStyle.Barlow500, MainStyle.f_s_36
  ]
};

export default React.memo(ContestFrame);
